import React, { Fragment } from 'react'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import CollectionHome from './CollectionHome';
import { useTranslation } from "react-i18next";

export default function CollectionList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Collections")} parent={t("Home")} title={t("List of Collections")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <CollectionHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
